export default "__VITE_PUBLIC_ASSET__64a976cb__"